import React from 'react'
import { Link } from 'react-router-dom'
import { SortableElement, SortableHandle } from 'react-sortable-hoc'
import isEmpty from 'lodash/isEmpty'

const DragHandle = SortableHandle(() => <div className="icon icon-sort"></div>) // This can be any component you want

export default SortableElement(({ value, updateLoading }) => {
    return (
        <li className={'sortable-category' + (updateLoading ? ' disabled' : '')}>
            <DragHandle />
            <div className="title">{value.title}</div>
            {!isEmpty(value.categories) &&
                <Link className="sub-sort-Link" to={'/admin/categories/sort/' + value.permalink}>Edit</Link>
            }
        </li>
    )
})



// WEBPACK FOOTER //
// ./src/components/admin/categories-sort/SortableElement.js